import { useState, useEffect } from 'react';

export const useInstruments = () => {
    const [instrumentMap, setInstrumentMap] = useState({});

    useEffect( () => {
        async function getInstruments() {
            const result = await fetch("/go/api/v1/instruments/search?size=6000");
            const json = await result.json();

            if (!json.hits || !json.hits.hits.length) {
                return;
            }
            const newMap = {};

            json.hits.hits.forEach((inst) => {
                newMap[inst._source.id] = inst._source.instrument;
            });

            setInstrumentMap(newMap);
        }

        getInstruments();
    }, []);

    return instrumentMap;
};
